import { render, staticRenderFns } from "./spis-icon.vue?vue&type=template&id=052dc61b&scoped=true"
import script from "./spis-icon.vue?vue&type=script&lang=js"
export * from "./spis-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052dc61b",
  null
  
)

export default component.exports